export const RATES = 'md_rates_GLOBAL';